// extracted by mini-css-extract-plugin
module.exports = {"component":"BurgerButton_component__0_544","icon":"BurgerButton_icon__n09m3","open":"BurgerButton_open__1Ju15"};